import {
  emailSchema,
  emailUI,
  internationalPhoneUI,
  internationalPhoneSchema,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['child-contact-title']),
    childEmail: emailUI(content.email),
    childPhone: internationalPhoneUI(content['primary-phone']),
  },
  schema: {
    type: 'object',
    required: ['childEmail', 'childPhone'],
    properties: {
      childEmail: emailSchema,
      childPhone: internationalPhoneSchema(),
    },
  },
};
